import React from 'react'
import { observer, inject } from 'mobx-react'

import anchorScroll from '../utils/anchorScroll'
import isLead from '../utils/isLead'
import Explore from './Explore'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons"
import config from '../utils/config'

const Footer = ({ commonStore, translationStore, errorStore, location }) => {
  return (
    <React.Fragment>

    { commonStore.withHeader &&
        <footer className='footer'>
          {
            isLead(location) && <div className='' />
          }
          <div className='footer__inner'>

            <div className='footer__inner__item'>
              <h3>{translationStore.translate('footer_text')}</h3>

              <div className='footer-social' id='footer-social-block'>
                  {/* <h3 className='font-bold'>{translationStore.translate('footer_social_title')}</h3> */}

                  { translationStore.translate('general_facebook_link') !== 'general_facebook_link' && 
                  <a rel='noopener noreferrer' href={translationStore.translate('general_facebook_link')} target='_blank'>
                      <FontAwesomeIcon icon={faFacebookF} />
                  </a>
                  }

                  { translationStore.translate('general_instagram_link') == 'general_instagram_link' && 
                  <a rel='noopener noreferrer' href={translationStore.translate('general_instagram_link')} target='_blank'>
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                  }

                  { translationStore.translate('general_youtube_link') == 'general_youtube_link' && 
                  <a rel='noopener noreferrer' href={translationStore.translate('general_instagram_link')} target='_blank'>
                    <FontAwesomeIcon icon={faYoutube} />
                  </a>
                  }
              </div>
            </div>

            <div className='footer__inner__item'>
              <h4>{translationStore.translate('footer_headline_shops_deals')}</h4>
              <Explore location={location} />
            </div>

            <div className='footer__inner__item'>
              {/* <h3 className='font-bold'>{translationStore.translate('footer_about_title')}</h3> */}
              <h4>{translationStore.translate('footer_headline_company')}</h4>
              <ul>
                <li>
                  <a onClick={() => anchorScroll('top', '/faq')}>{translationStore.translate('footer_support_general')}</a>
                </li>
                <li>
                  <a onClick={() => anchorScroll('#cashback', '/faq')}>{translationStore.translate('footer_support_cashback')}</a>
                </li>
                <li>
                  <a onClick={() => anchorScroll('#payoff', '/faq')}>{translationStore.translate('footer_support_payoff')}</a>
                </li>
                <li>
                  <a onClick={() => anchorScroll('#account', '/faq')}>{translationStore.translate('footer_support_account')}</a>
                </li>
                {/* <li>
                  <a target='_blank' rel='external' href={translationStore.translate('general_blog_link')}>{translationStore.translate('footer_blog')}</a>
                </li> */}
                <li>
                  <a onClick={() => anchorScroll('top', '/contact')}>{translationStore.translate('footer_contact')}</a>
                </li>
              </ul>
              {
                (!commonStore.isLoggedIn)
                  ? (<ul>
                    <li>
                      <a onClick={() => anchorScroll('top', '/registration')}>{translationStore.translate('footer_my_register')}</a>
                    </li>
                    <li>
                      <a onClick={() => anchorScroll('top', '/login')}>{translationStore.translate('footer_my_login')}</a>
                    </li>
                  </ul>)
                  : (<ul>
                    <li>
                      <a onClick={() => anchorScroll('top', '/profile')}>{translationStore.translate('footer_my_account')}</a>
                    </li>
                  </ul>)
              }
            </div>
 
            <div className='footer__inner__after'>
                <p>© {(new Date().getFullYear())}
                  {' ' + translationStore.translate('footer_copyright')}
                </p>
                <a onClick={() => anchorScroll('top', '/page/privacy')}>{translationStore.translate('footer_privacy')}</a>
                <a onClick={() => anchorScroll('top', '/page/gtc')}>{translationStore.translate('footer_gtc')}</a>
                <a onClick={() => anchorScroll('top', '/page/imprint')}>{translationStore.translate('footer_imprint')}</a>
                <a onClick={() => anchorScroll('top', '/page/cancellation')}>Widerrufsbelehrung</a>
            </div>
          </div>
        </footer>
    }
    </React.Fragment>
  )
}

export default inject('commonStore', 'translationStore', 'errorStore')(observer(Footer))



// WEBPACK FOOTER //
// ./src/components/Footer.js